export const getNews = {
    2025: [
        // {
        //     year: 2025,
        //     month: 11,
        //     monthText: "Novembre",
        //     dayNews: [
        //         {
        //             day: 12,
        //             dayText: "Mar",
        //             newsText: "Apertura straordinaria, dalle 08:00 alle 22:00 Apertura straordinaria, dalle 08:00 alle 22:00 Apertura straordinaria, dalle 08:00 alle 22:00 Apertura straordinaria, dalle 08:00 alle 22:00 Apertura straordinaria, dalle 08:00 alle 22:00 Apertura straordinaria, dalle 08:00 alle 22:00",
        //         },
        //         {
        //             day: 27,
        //             dayText: "Mer",
        //             newsText: "Apertura straordinaria, dalle 08:00 alle 22:00",
        //         },
        //         {
        //             day: 21,
        //             dayText: "Gio",
        //             newsText: "Apertura straordinaria, dalle 08:00 alle 22:00",
        //         },
        //     ]
        // }
    ],
    2026: [
        // {
        //     year: 2026,
        //     month: 11,
        //     monthText: "Novembre",
        //     dayNews: [
        //         {
        //             day: 12,
        //             dayText: "Mar",
        //             newsText: "Apertura straordinaria, dalle 08:00 alle 22:00 Apertura straordinaria, dalle 08:00 alle 22:00 Apertura straordinaria, dalle 08:00 alle 22:00 Apertura straordinaria, dalle 08:00 alle 22:00 Apertura straordinaria, dalle 08:00 alle 22:00 Apertura straordinaria, dalle 08:00 alle 22:00",
        //         },
        //         {
        //             day: 27,
        //             dayText: "Mer",
        //             newsText: "Apertura straordinaria, dalle 08:00 alle 22:00",
        //         },
        //         {
        //             day: 21,
        //             dayText: "Gio",
        //             newsText: "Apertura straordinaria, dalle 08:00 alle 22:00",
        //         },
        //     ]
        // }
    ],

}